import { Component, Output, EventEmitter, AfterViewInit, inject, viewChild } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { IAdvertiserQueryRequestDto } from 'src/app/api/api-campaigns.service.generated';
import { ObjectCleaner } from 'src/app/common/utils/ObjectCleaner';
import { MatDrawer, MatDrawerContainer, MatDrawerContent } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MultiLabelsComponent } from 'src/app/common/components/multi-labels/multi-labels.component';
import { ButtonComponent } from "wecheer-common";

@Component({
    selector: 'app-advertiser-filters',
    templateUrl: './advertiser-filters.component.html',
    styleUrls: ['./advertiser-filters.component.scss'],

    imports: [
    ReactiveFormsModule,
    MatDrawerContainer,
    MatDrawerContent,
    MatDrawer,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MultiLabelsComponent,
    ButtonComponent
]
})
export class AdvertiserFiltersComponent implements AfterViewInit {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);


  // #region props
  @Output() search = new EventEmitter<IAdvertiserQueryRequestDto>();
  readonly drawerFilters = viewChild<MatDrawer>('drawerFilters');

  form: FormGroup = new FormGroup({
    names: new FormControl(null),
    state: new FormControl('-')
  });

  filter: IAdvertiserQueryRequestDto;

  ngAfterViewInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.setFormValuesFromQueryParams(params);
      this.filter = this.getFormValues();
      this.search.emit(this.filter);
      this.drawerFilters().close();
    });
  }

  getFormValues(): IAdvertiserQueryRequestDto {
    return {
      names: this.form.value.names
    };
  }

  onReset() {
    this.form.reset({});
    this.onSubmit();
  }

  onSubmit() {
    const filter = this.getFormValues();
    this.filter = filter;
    // this.search.emit(this.filter);

    const params = ObjectCleaner.removeEmptyProperties(this.filter);
    this.router.navigate([], {
      queryParams: {
        ...params,
        v: this.unique_id() // add random param value to create unique query string - to trigger queryParams change even if no param has changed
      }
    });
  }

  open() {
    this.drawerFilters().open();
  }

  setFormValuesFromQueryParams(params: Params) {
    this.form.patchValue({
      ...params,
      names: this.ensureArray(params.names),
      state: params.state === undefined ? '-' : params.state
    });
  }

  ensureArray(val: any) {
    return val ? (Array.isArray(val) ? val : [val]) : undefined;
  }

  unique_id() {
    return 'xxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

}
